import { whistleblowerRetaliationProtectedCommunicationContact } from '../../../../choices'
import { otherChoicePage } from '../../../../pages'
import css from '../../../ComplaintForm/ComplaintForm.module.css'

export const protectedCommunicationPage = () => {
  const props = {
    pageId: 'protected_communication_page',
    fieldName: 'communication_contact',
    fieldNameOther: 'communication_contact_other',
    label: 'Who did you make your complaint to?',
    labelOther: 'Please enter the other recipient',
    fieldType: 'checkbox',
    className: css.choices,
    labelClassName: css.largeLabel,
    choices: whistleblowerRetaliationProtectedCommunicationContact()
  }

  const page = otherChoicePage({ ...props })

  return {
    ...page,
    action: {
      type: 'goto',
      pageId: values => {
        return values.communication_contact.includes('Other')
          ? 'protected_communication_warning_page'
          : 'protected_disclosure_date_page'
      }
    }
  }
}
